<template>
    <modal @modal-close="handleClose">
        <div class="modal-wrapper">
            <CloseButton @click="handleClose" />

            <div class="modal-content">
                <div class="p-8">
                    <div class="text-center text-80 leading-normal " v-if="Object.keys(message).length">
                        <p class="font-semibold text-xl" v-if="message.limit">{{ message.limit + '/' + message.limit }}</p>
                        <p>{{ $t('This feature is not included in your free plan.') }}</p>
                        <p v-if="message.advice">{{ message.advice }}</p>
                    </div>
                </div>

                <div class="modal-actions-outer-wrapper">
                    <div class="modal-actions-inner-wrapper">
                        <button
                            type="button"
                            class="modal-actions-secondary"
                            @click.prevent="handleClose"
                        >
                            {{ $t('OK') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import CloseButton from '@/components/Modals/CloseButton.vue';

export default {
    name: 'ModalFreePlan',

    components: { CloseButton },

    props: {
        message: {
            type: Object,
            default: () => {},
        },
    },

    methods: {
        handleClose() {
            this.$emit('close');
        },
    },
};
</script>
